import React from 'react'
import { useContext } from "react";
import { Context } from "../../container/DatePicker";
import {useTranslation} from "react-i18next";

function MonthPicker() {

    const { t } = useTranslation()
    const cal_months = [
        t('months.jan'),
        t('months.feb'),
        t('months.mar'),
        t('months.apr'),
        t('months.may'),
        t('months.jun'),
        t('months.jul'),
        t('months.aug'),
        t('months.sep'),
        t('months.oct'),
        t('months.nov'),
        t('months.dec'),
    ]

    let { date, setDate } = useContext(Context);

    const selectedMonth = (e, month) => {

        return setDate(
            {
                dateTime: new Date(date.dateTime.setMonth(month)),
                isDaysList: true,
                isMonthsList: false,
                isYearsList: false
            }
        );
    }
    return (
        <div className="month-grid-container">
            {
                cal_months.map((month, i) => {
                    return <span className="month-grid-item" key={month}
                        style={{
                            'background': month == cal_months[date.dateTime.getMonth()] ? '#1A1C3A' : '',
                            'color': month == cal_months[date.dateTime.getMonth()] ? '#FCFCFC' : '#1A1C3A'
                        }}

                        onClick={((e) => selectedMonth(e, i))}>{month}</span>
                })
            }
        </div>
    );
}

export default MonthPicker;
